import * as React from 'react';
import withStyles, { WithStylesProps } from 'react-jss';
import { Modal, Table, Image } from 'antd';
import { CssType, ThemeType } from '../theme/jss-types';
import { ReadWithSignedUrl } from './ReadWithSignedUrl';
import { StylesProps } from 'src/library/types';
import { useTranslation } from 'react-i18next'; // Import translation hook

const styles = (theme: ThemeType) => ({
  tableContainer: {
    flex: '1 1 0',
    overflow: 'auto',
    height: 300,
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.25)',
    '& .ant-table-tbody > tr > td, .ant-table-thead > tr > th': {
      padding: 9,
    },
  },
});

interface TableModalProps extends StylesProps<ReturnType<typeof styles>> {
    columnsToShow: Array<{
      pretty_name: string;
      column_id: string;
      width?: number;
      is_signed_url?: boolean;
    }>;
    dataSource: Array<any>;
    classes: any;
    isVisible: boolean;
    header: string;
    handleModalClose: () => void;
    showDescription?: boolean;
    descriptionText?: string;
    width?: number;
}

const TableModal = (props: TableModalProps) => {
  const {
    columnsToShow,
    dataSource,
    isVisible,
    classes,
    header,
    handleModalClose,
    showDescription = false,
    descriptionText,
    width = 900,
  } = props;
  const { t } = useTranslation();

  const generateDataColumns = (): Array<any> => {
    const columnData: any = [
      {
        title: 'S.No.',
        key: 'index',
        render: (text, record, index) => index + 1,
        width: 20,
      },
    ];

    columnsToShow.forEach((item) => {
      const itemToPush: any = {};
      itemToPush['title'] = t(item.pretty_name);
      itemToPush['dataIndex'] = item.column_id;
      itemToPush['width'] = item?.width || 50;
      itemToPush['key'] = item.column_id;

      if (item.column_id === 'image') {
        itemToPush['render'] = (x: string, record: any) => {
          return x ? (
            <Image.PreviewGroup>
              {item.is_signed_url ? (
                <ReadWithSignedUrl
                  url={x}
                  renderingCb={(signedUrl: string) => (
                    <Image src={signedUrl} style={{ maxWidth: '450px', maxHeight: '450px' }} />
                  )}
                />
              ) : (
                <Image src={x} style={{ maxWidth: '450px', maxHeight: '450px' }} />
              )}
            </Image.PreviewGroup>
          ) : t('Not Available');
        };
      }
      columnData.push(itemToPush);
    });
    return columnData;
  };

  return (
    <Modal
      title={header}
      width={width}
      visible={isVisible}
      footer={null}
      onCancel={handleModalClose}
      destroyOnClose
    >
      {showDescription && descriptionText ? (
        <div style={{ marginBottom: '10px' }}>
          <span>{descriptionText}</span>
        </div>
      ) : null}
      <div className={classes.tableContainer}>
        <Table
          locale={{ emptyText: `No ${header}` }}
          pagination={false}
          dataSource={dataSource}
          columns={generateDataColumns()}
        />
      </div>
    </Modal>
  );
};

export default withStyles(styles, { injectTheme: true })(TableModal);
